// extracted by mini-css-extract-plugin
module.exports = {"root":"TabContent_root__2k5xO"};